import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Pipe({
  name: 'getPublishFormGroupScheduleJobDueTime'
})
export class GetPublishFormGroupScheduleJobDueTimePipe implements PipeTransform {

  transform(value: FormGroup): AbstractControl {
    if (value.get('publishFormGroup')) {
      return value.get('publishFormGroup').get('scheduleJob').get('dueTime');
    } else {
      return null;
    }
  }

}
